module.exports = __webpack_public_path__ + "static/media/patrol(4).2e728e26.PNG";